/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Event_FinishedInputs */



/**
* | output |
* | --- |
* | "This event has finished." |
*
* @param {Tournament_Event_FinishedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_event_finished = /** @type {((inputs?: Tournament_Event_FinishedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Event_FinishedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cet événement est terminé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este evento ha finalizado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este evento foi finalizado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo evento si è concluso.")
	return /** @type {LocalizedString} */ ("This event has finished.")
});